export default "__VITE_ASSET__B_97fldf__"